import ProfileService from "@/services/profile.service"

const initialState = { userProfile: null, token: null, isAuthenticated: localStorage.getItem("authToken") ? true : false };

export const profile = {
    namespaced: true,
    state: initialState,
    actions: {

        async login({ commit }, data) {
            const authResponse = await ProfileService.login(data.username, data.password);
            commit('successLogin', authResponse.token);
        },

        async getProfile({ commit }) {
            const userProfile = await ProfileService.getProfile();
            commit('success', userProfile);
        },

        async editProfile({ commit }, modifiedProfile) {
            const userProfile = await ProfileService.editProfile(modifiedProfile);
            commit('success', userProfile);
        },

        //eslint-disable-next-line no-unused-vars
        async uploadPic({ commit }, file) {
           const picURL = (await ProfileService.uploadPic(file, this.state.profile.userProfile.id)).url;
           commit('successUpload', picURL);
        },

        

    },
    mutations: {
        successLogin(state, token) {
            state.token = token;
            state.isAuthenticated = true;
            localStorage.setItem("authToken", token);
        },
        success(state, userProfile) {
            state.userProfile = userProfile;
        },
        successUpload(state, picURL){
            state.userProfile.profile_image = picURL;
        }
    },
    getters: {
        getUserProfile(state){
            return state.userProfile
        },
        getUserProfileImage(state){
            return state.userProfile.profile_image
        },
        isAuthenticated(state){
            return state.isAuthenticated;
        }
    }
}